export default {
  benefits: {
    earn_points: 'Optjen point med hver ordre',
    get_deals: 'Få eksklusive rabatter',
    redeem_points: 'Indløs point til gratis mad',
  },
};
